// extracted by mini-css-extract-plugin
export default {"white_border":"BenefitGroup_white_border__lly43"};